export default __webpack_public_path__ + "static/media/2936.ab889bb4.png";